import { shallowEqual, useSelector } from 'react-redux';
import { getPlayers } from '../selectors';

export const usePlayers = () => ({
  players: useSelector(getPlayers, shallowEqual),
});
